var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashbord_cla" }, [
    _vm.companyNum > 0
      ? _c(
          "div",
          { staticClass: "grid-content to-data", on: { click: _vm.toCompany } },
          [
            _c(
              "charItem",
              [
                _c("i", {
                  staticClass: "zk-icon-qiyexinxi icon_cla",
                  attrs: { slot: "icon" },
                  slot: "icon"
                }),
                _vm._v(" "),
                _c("template", { slot: "number" }, [
                  _c("span", { staticClass: "tip_cla" }, [
                    _vm._v(_vm._s(_vm.$t("developer.companyNum")) + "：")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "num_cla" }, [
                    _vm._v(_vm._s(_vm.companyNum))
                  ])
                ])
              ],
              2
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-content to-data", on: { click: _vm.toDevice } },
      [
        _c(
          "charItem",
          [
            _c("i", {
              staticClass: "shebeiliebiao-cla",
              attrs: { slot: "icon" },
              slot: "icon"
            }),
            _vm._v(" "),
            _c("template", { slot: "number" }, [
              _c("span", { staticClass: "tip_cla" }, [
                _vm._v(_vm._s(_vm.$t("developer.deviceTotle")) + "：")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "num_cla" }, [
                _vm._v(_vm._s(_vm.total))
              ])
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-content" },
      [
        _c(
          "charItem",
          [
            _c("i", {
              staticClass: "zk-icon-wifi icon_cla",
              attrs: { slot: "icon" },
              slot: "icon"
            }),
            _vm._v(" "),
            _c("template", { slot: "number" }, [
              _c("span", { staticClass: "tip_cla" }, [
                _vm._v(_vm._s(_vm.$t("developer.onLineCount")) + "：")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "num_cla" }, [
                _vm._v(_vm._s(_vm.online))
              ])
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-content" },
      [
        _c(
          "charItem",
          [
            _c("i", {
              staticClass: "zk-icon-lixian1 icon_cla",
              attrs: { slot: "icon" },
              slot: "icon"
            }),
            _vm._v(" "),
            _c("template", { slot: "number" }, [
              _c("span", { staticClass: "tip_cla" }, [
                _vm._v(_vm._s(_vm.$t("developer.offlineCount")) + "：")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "num_cla" }, [
                _vm._v(_vm._s(_vm.offline))
              ])
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-content" },
      [
        _c(
          "charItem",
          [
            _c("i", {
              staticClass: "iconfont zk-icon-jinyong_2 icon_cla",
              attrs: { slot: "icon" },
              slot: "icon"
            }),
            _vm._v(" "),
            _c("template", { slot: "number" }, [
              _c("span", { staticClass: "tip_cla" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.disableDevice")) + "：")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "num_cla" }, [
                _vm._v(_vm._s(_vm.disableNum))
              ])
            ])
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "grid-content to-data",
        on: { click: _vm.toDataTransferStation }
      },
      [
        _c(
          "charItem",
          [
            _c("i", {
              staticClass: "TransferStation-icon-cla",
              attrs: { slot: "icon" },
              slot: "icon"
            }),
            _vm._v(" "),
            _c("template", { slot: "number" }, [
              _c("span", { staticClass: "tip_cla" }, [
                _vm._v(_vm._s(_vm.$t("developer.relayNum")) + "：")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "num_cla" }, [
                _vm._v(_vm._s(_vm.relayNum))
              ])
            ])
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b6ed28c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6ed28c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/developer/appSetting/dashboard.vue
// module id = null
// module chunks = 